import axios from 'axios';

export async function searchEnterpriseLocations(searchCriteria) {
  const requestBody = { searchCriteria };
  const response = await axios.post('/enterprise/searchLocations', requestBody);
  return response;
}

export async function createEnterpriseRental(claimId, policyOverride, rentalLocation, vehicleCondition, emailAddress) {
  const requestBody = { claimId, policyOverride, rentalLocation, vehicleCondition, emailAddress };
  const response = await axios.post('/enterprise/createRental', requestBody);
  return response;
}

export async function searchAudatargetVendor(searchCriteria) {
  const requestBody = { searchCriteria };
  const response = await axios.post('/audatarget/searchVendor', requestBody);
  return response;
}

export async function audatargetGetAvailibility(searchCriteria) {
  const requestBody = { searchCriteria };
  const response = await axios.post('/audatarget/availability', requestBody);
  return response;
}

export async function audatargetBookAppointment(searchCriteria) {
  const requestBody = { searchCriteria };
  const response = await axios.post('/audatarget/bookAppointment', requestBody);
  return response;
}
